import { render, staticRenderFns } from "./modal-production-add-workers.vue?vue&type=template&id=2f165b9f&scoped=true&"
import script from "./modal-production-add-workers.vue?vue&type=script&lang=js&"
export * from "./modal-production-add-workers.vue?vue&type=script&lang=js&"
import style0 from "./modal-production-add-workers.vue?vue&type=style&index=0&id=2f165b9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f165b9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f165b9f')) {
      api.createRecord('2f165b9f', component.options)
    } else {
      api.reload('2f165b9f', component.options)
    }
    module.hot.accept("./modal-production-add-workers.vue?vue&type=template&id=2f165b9f&scoped=true&", function () {
      api.rerender('2f165b9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/modal-production-add-workers.vue"
export default component.exports